// #1981: de fases van een periodisering. Toevoegen, dupliceren, verwijderen,
// omhoog/omlaag en slepen; per fase en in totaal live de berekening
// weken × trainingen per week. De server rekent bij het opslaan opnieuw en
// controleert of de weken bij de template passen (Schemaplanning).
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["lijst", "sjabloon", "fase", "totaalFases", "totaalWeken", "totaalSessies", "tijdlijn"]
  static values = { reken: String, fout: String, leeg: String }

  connect() {
    this.teller = Date.now()
    this.herbereken()
  }

  toevoegen() {
    const html = this.sjabloonTarget.innerHTML.replace(/NIEUWE_FASE/g, this.nieuweIndex())
    this.lijstTarget.insertAdjacentHTML("beforeend", html)
    this.herbereken()
    const velden = this.zichtbareFases()
    velden[velden.length - 1]?.querySelector("[data-fase-template]")?.focus()
  }

  dupliceer(event) {
    const bron = event.target.closest("[data-periodisering-fases-target='fase']")
    if (!bron) return

    const index = this.nieuweIndex()
    const kopie = bron.cloneNode(true)
    kopie.querySelector("[data-fase-id]")?.remove()
    kopie.querySelectorAll("[name]").forEach((veld) => {
      veld.name = veld.name.replace(/\[fases_attributes\]\[[^\]]+\]/, `[fases_attributes][${index}]`)
      if (veld.id) veld.id = veld.id.replace(/fases_attributes_[^_]+_/, `fases_attributes_${index}_`)
    })
    kopie.querySelectorAll("label[for]").forEach((label) => {
      label.htmlFor = label.htmlFor.replace(/fases_attributes_[^_]+_/, `fases_attributes_${index}_`)
    })
    // de gekozen template gaat mee; cloneNode neemt de selectie van een select niet over
    const bronSelect = bron.querySelector("[data-fase-template]")
    const kopieSelect = kopie.querySelector("[data-fase-template]")
    if (bronSelect && kopieSelect) kopieSelect.value = bronSelect.value
    bron.after(kopie)
    this.herbereken()
  }

  verwijder(event) {
    const fase = event.target.closest("[data-periodisering-fases-target='fase']")
    if (!fase) return

    const weg = fase.querySelector("[data-fase-weg]")
    if (fase.querySelector("[data-fase-id]")) {
      weg.value = "1"
      fase.hidden = true
    } else {
      fase.remove()
    }
    this.herbereken()
  }

  omhoog(event) {
    const fase = event.target.closest("[data-periodisering-fases-target='fase']")
    const vorige = this.buur(fase, -1)
    if (fase && vorige) vorige.before(fase)
    this.herbereken()
  }

  omlaag(event) {
    const fase = event.target.closest("[data-periodisering-fases-target='fase']")
    const volgende = this.buur(fase, 1)
    if (fase && volgende) volgende.after(fase)
    this.herbereken()
  }

  // ---- slepen ----

  sleepBegin(event) {
    this.gesleept = event.currentTarget
    this.gesleept.classList.add("is-slepend")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", "fase")
  }

  sleepOver(event) {
    if (!this.gesleept) return
    event.preventDefault()
    const doel = event.currentTarget
    if (doel === this.gesleept) return

    const vak = doel.getBoundingClientRect()
    const erna = event.clientY > vak.top + vak.height / 2
    erna ? doel.after(this.gesleept) : doel.before(this.gesleept)
  }

  sleepNeer(event) {
    event.preventDefault()
    this.herbereken()
  }

  sleepEind() {
    this.gesleept?.classList.remove("is-slepend")
    this.gesleept = null
    this.herbereken()
  }

  // ---- rekenen ----

  herbereken() {
    let weken = 0
    let sessies = 0
    const delen = []
    this.zichtbareFases().forEach((fase, i) => {
      fase.querySelector("[data-fase-nummer]").textContent = i + 1
      fase.querySelector("[data-fase-positie]").value = i + 1

      const optie = fase.querySelector("[data-fase-template]")?.selectedOptions?.[0]
      const faseWeken = parseInt(fase.querySelector("[data-fase-weken]")?.value, 10) || 0
      const perWeek = parseInt(optie?.dataset?.perWeek, 10) || 0
      const trainingen = parseInt(optie?.dataset?.trainingen, 10) || 1
      const faseSessies = faseWeken * perWeek
      const reken = fase.querySelector("[data-fase-reken]")
      if (!optie || !optie.value) {
        reken.textContent = this.leegValue
        reken.classList.remove("is-fout")
      } else if (faseSessies % trainingen !== 0) {
        reken.textContent = this.vul(this.foutValue, { weken: faseWeken, per_week: perWeek, sessies: faseSessies, trainingen })
        reken.classList.add("is-fout")
      } else {
        reken.textContent = this.vul(this.rekenValue, { weken: faseWeken, per_week: perWeek, sessies: faseSessies })
        reken.classList.remove("is-fout")
      }
      weken += faseWeken
      sessies += faseSessies
      delen.push(faseWeken)
    })

    if (this.hasTotaalFasesTarget) this.totaalFasesTarget.textContent = delen.length
    if (this.hasTotaalWekenTarget) this.totaalWekenTarget.textContent = weken
    if (this.hasTotaalSessiesTarget) this.totaalSessiesTarget.textContent = sessies
    if (this.hasTijdlijnTarget) {
      this.tijdlijnTarget.innerHTML = ""
      delen.forEach((deel) => {
        const balk = document.createElement("span")
        balk.style.width = weken > 0 ? `${(deel / weken) * 100}%` : "0"
        this.tijdlijnTarget.appendChild(balk)
      })
    }
  }

  // ---- hulpjes ----

  zichtbareFases() {
    return this.faseTargets.filter((fase) => !fase.hidden && !fase.closest("template"))
  }

  buur(fase, richting) {
    const lijst = this.zichtbareFases()
    const index = lijst.indexOf(fase)
    return index < 0 ? null : lijst[index + richting]
  }

  nieuweIndex() {
    this.teller += 1
    return this.teller
  }

  vul(tekst, waarden) {
    return Object.entries(waarden).reduce((uit, [sleutel, waarde]) => uit.replaceAll(`{${sleutel}}`, waarde), tekst)
  }
}
